export var ActionToolsValidationError;
(function (ActionToolsValidationError) {
    ActionToolsValidationError["SHORT_TITLE"] = "SHORT_TITLE";
    ActionToolsValidationError["INVALID_FORMAT_TITLE"] = "INVALID_FORMAT_TITLE";
    ActionToolsValidationError["MISSING_DESCRIPTION"] = "MISSING_DESCRIPTION";
    ActionToolsValidationError["DUPLICATE_TITLE"] = "DUPLICATE_TITLE";
    ActionToolsValidationError["INVALID_INPUT_SCHEMA"] = "INVALID_INPUT_SCHEMA";
})(ActionToolsValidationError || (ActionToolsValidationError = {}));
/**
 * Validates an ActionViewModel object to ensure it meets the requirements for action tools.
 *
 * Requirements:
 * - $title must be present and match the identifier pattern (lowercase alphanumeric and underscores, at least 3 chars)
 * - $description must be present
 * - $inputSchema must be an object
 *
 * @param {ActionViewModel} action - The action view model to validate.
 * @returns {Object} An object containing:
 *  - validTitle: boolean indicating if the title is valid.
 * - isUniqueTitle: boolean indicating if the title is unique within the state.
 */
export const validateActionViewModelToActionTools = (action, state) => {
    const errors = validationHandlers.reduce((acc, handler) => handler(action, state, acc), []);
    return {
        validTitle: !errors.includes(ActionToolsValidationError.INVALID_FORMAT_TITLE),
        isUniqueTitle: !errors.includes(ActionToolsValidationError.DUPLICATE_TITLE),
        errors,
    };
};
const validationHandlers = [
    validateName,
    validateDescription,
    validateInputSchema,
    validateDuplicatedTitle,
];
function validateName(action, state, errorsList) {
    const IDENTIFIER_REGEXP = /^[a-z0-9_]{3,}$/;
    if (!action.$title || action.$title.length < 3) {
        errorsList.push(ActionToolsValidationError.SHORT_TITLE);
        return errorsList;
    }
    if (!IDENTIFIER_REGEXP.test(action.$title)) {
        errorsList.push(ActionToolsValidationError.INVALID_FORMAT_TITLE);
    }
    return errorsList;
}
function validateDescription(action, state, errorsList) {
    if (!action.$description || action.$description.length < 3) {
        errorsList.push(ActionToolsValidationError.MISSING_DESCRIPTION);
    }
    return errorsList;
}
function validateInputSchema(action, state, errorsList) {
    if (!action.$inputSchema || typeof action.$inputSchema !== 'object') {
        errorsList.push(ActionToolsValidationError.INVALID_INPUT_SCHEMA);
    }
    return errorsList;
}
function validateDuplicatedTitle(action, state, errorsList) {
    const isDuplicated = state.$localCustomActions.some((existingAction) => existingAction.$title === action.$title && existingAction.$id !== action.$id);
    if (isDuplicated) {
        errorsList.push(ActionToolsValidationError.DUPLICATE_TITLE);
    }
    return errorsList;
}
